import React from 'react';
function Publish({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M11.777 9.526c-1.418.161-3.721.413-6.906.756a1.051 1.051 0 00-.743 1.053c.011.496.313 1.011.795 1.355l11.55 8.088c.488.335 1.077.443 1.546.283a1.052 1.052 0 00.736-1.058c-.734-2.996-1.283-5.245-1.645-6.743"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M17.973 12.032c1.36-1.944 2.433-3.946 2.155-6.584-.027-.252-.04-.72-.7-1.181-.555-.39-1.02-.253-1.337-.202-2.544.411-4.106 2.288-5.461 4.225l-.539.769-4.064 5.805 1.703 1.191 1.747 1.224 1.893 1.326 4.065-5.805.537-.768h0zM11.946 14.953L9.45 18.515"
      />
      <path strokeLinecap="square" strokeLinejoin="round" d="M15.553 8.852l.891.624" />
    </svg>
  );
}

export default Publish;
